import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = ["type", "id", "value"]

import { nextTick, onMounted, ref } from 'vue';

interface AppInputProps {
	type?: string;
	id: string;
	modelValue?: string | number;
	autofocus?: boolean;
}


export default /*@__PURE__*/_defineComponent({
  __name: 'AppInput',
  props: {
    type: { default: 'text' },
    id: {},
    modelValue: {},
    autofocus: { type: Boolean, default: false }
  },
  emits: ['update:modelValue'],
  setup(__props: any, { emit: __emit }) {

const props = __props;

const element = ref<HTMLInputElement | undefined>();

const emit = __emit;

onMounted(() => {
	if (!props.autofocus) {
		return;
	}

	nextTick(() => {
		if (element.value) {
			element.value.focus();
		}
	});
});

const inputUpdated = (e) => {
	emit('update:modelValue', e.target.value);
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("input", {
    ref_key: "element",
    ref: element,
    type: __props.type,
    id: __props.id,
    value: __props.modelValue,
    onInput: inputUpdated
  }, null, 40, _hoisted_1))
}
}

})